var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77533 6.45778V10.0024H0.783203V14.378H4.77533V24.2371H9.49988V14.378H13.5257L14.0076 10.0047H9.49988V6.45778C9.49988 5.83101 10.0082 5.51881 10.2227 5.32632C10.6009 5.01177 12.4271 4.96247 12.4271 4.96247H14.2172V0.997681C13.2848 0.861531 12.3452 0.784066 11.4032 0.762939C4.63801 0.762939 4.77533 6.45778 4.77533 6.45778Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export default SvgFacebook;